import axios from 'axios';
import { user as userEndpoints } from '../../constants/endpoints';

export default class Impersonation {
  /** Trades the one-time code of a platform admin's "sign in as" link for a session of that user. */
  static async call(code: string): Promise<void> {
    const { data } = await axios.post<{ token: string }>(userEndpoints.impersonation, { code });

    // Replaces whoever was signed in on this browser; the impersonated login arrives with /user/me
    window.localStorage.removeItem('login');
    window.localStorage.setItem('accessToken', data.token);
  }
}
